



















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import MultiselectList from '@/components/MultiselectList.vue'
import EditPaymentDialog from '@/views/payments/EditPaymentDialog.vue'
import DenyDialog from '@/views/payments/DenyPaymentsDialog.vue'
import CompletePaymentsDialog from '@/views/payments/CompletePaymentsDialog.vue'

import { Payment, isDebit, statusColor } from '@/types/Payments'
import { currentUserIs, Managers } from '@/types/Users'

dayjs.extend(relativeTime)

@Component({
  components: {
    MultiselectList,
    EditPaymentDialog,
    CompletePaymentsDialog,
    DenyDialog,
  },
})
export default class PaymentsList extends Vue {
  
  selectedPaymentIds: number[] = []
  editPaymentDialog = false
  approveDialog = false
  denyDialog = false
  paymentDialog = false
  loadingMore = false

  @Prop({ required: true }) payments!: Payment[]
  @Prop({ default: false }) editable!: boolean
  @Prop({ type: String, required: true }) title!: string
  @Prop({ type: String }) shortTitle?: string
  @Prop({ default: false }) loading!: boolean
  
  clearSelection() {
    this.selectedPaymentIds = []
  }

  get me() {
    return this.$store.getters.me
  }

  get balance() {
    return this.$store.state.payments.balance
  }
  
  get userIsManager() {
    return currentUserIs(...Managers)
  }

  get paymentsSorted() {
    return this.payments.sort((a, b) => {
      if (a.date_completed && b.date_completed) {
        return dayjs(b.date_completed).diff(dayjs(a.date_completed))
      }
      return b.id - a.id
    })
  }

  // Sum the amount of all selected payments
  get selectedTotal() {
    return this.selectedPaymentIds.reduce((total, id) => {
      const payment = this.payments.find((p: Payment) => p.id === id)
      return total + (payment ? parseFloat(payment.total) : 0)
    }, 0)
  }

  isDebit(payment: Payment) {
    return isDebit(payment)
  }

  hasSufficientBalance(paymentId: number) {

    let paymentIds = []

    if (paymentId) paymentIds = [paymentId]
    else if (!this.selectedPaymentIds.length) paymentIds = this.payments.map((p: Payment) => p.id)
    else paymentIds = this.selectedPaymentIds

    const payments: Payment[] = this.$store.getters.paymentsByIds(paymentIds)

    const totalPayment = payments.reduce((total: number, payment: Payment) => {
      return total + (payment ? parseFloat(payment.total) : 0)
    }, 0)

    return Math.round(totalPayment * 100) / 100 <= parseFloat(this.balance.value)
  }

  timeDiff(timeIn: string, timeOut: string) {
    const _in = dayjs(timeIn)
    const _out = dayjs(timeOut)
    return _out.from(_in, true)
  }


  selectAll() {
    this.selectedPaymentIds = this.payments.map((t: Payment) => t.id)
  }

  deselectAll() {
    this.selectedPaymentIds = []
  }

  openEditPaymentDialog(paymentId: number) {
    this.selectedPaymentIds = [paymentId]
    this.editPaymentDialog = true
  }

  openDenyDialog(paymentId: number) {
    if (paymentId) this.selectedPaymentIds = [paymentId]
    else if (!this.selectedPaymentIds.length) this.selectAll()
    this.denyDialog = true
  }

  openPaymentDialog(paymentId: number) {
    if (paymentId) this.selectedPaymentIds = [paymentId]
    else if (!this.selectedPaymentIds.length) this.selectAll()
    this.paymentDialog = true
  }

  statusColor(status: string) {
    return statusColor(status)
  }
}
